module.exports = __webpack_public_path__ + "static/media/29.81acd0e9.jpg";